import { render } from "./CompanyDescription.vue?vue&type=template&id=a19971e8&scoped=true"
import script from "./CompanyDescription.vue?vue&type=script&lang=js"
export * from "./CompanyDescription.vue?vue&type=script&lang=js"

import "./CompanyDescription.vue?vue&type=style&index=0&id=a19971e8&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19971e8"]])

export default __exports__